<template>
  <v-autocomplete
    hide-details="auto"
    :items="Unit"
    :loading="loading"
    v-model="selectedUnit"
    item-text="name"
    item-value="id"
    label="Unit"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchUnit"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Unit: [],
    selectedUnit: null,
    searchUnit:null,
    loading:false
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedUnit);
    },
    getUnitByQuery(query = "") {
        
      this.loading = true;
      this.$store
        .dispatch("Unit/GetUnits", {
          query: query,
          status: "active",
        })
        .then((res) => {
          this.Unit = res.data.data
          this.loading = false;

        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedUnit = null;
      },
      deep: true,
    },
    searchUnit: {
      handler(val) {
        this.getUnitByQuery(val);
      },
      deep: true,
    },
  },
  created(){
    this.getUnitByQuery()
  }
};
</script>